<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left col-lg-6 row p-0 m-0">
        <span class="col-lg-6 m-0 p-0 text-left">
          <h4>{{ $t('keyValues') }}</h4>
        </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addKeyValue">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="$t('keyValues')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/controls/PaginatedTable.vue'
import SearchBar from '@/controls/SearchBar.vue'
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      searchText: '',
      caption: i18n.t('keyValues'),
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'key', label: i18n.t('keyMandatory').replace('*', ''), _classes: 'font-weight-bold', sortable: true },
        { key: 'value', label: i18n.t('valueMandatory').replace('*', ''), sortable: true },
      ],
      actions: [
        { key: 'view', label: i18n.t('view'), icon: 'cil-magnifying-glass' },
        { key: 'edit', label: i18n.t('edit'), icon: 'cil-pencil' },
        { key: 'delete', label: i18n.t('delete'), icon: 'cil-trash' }
      ],
      sorterValue: { column: 'id', asc: true },
      loading: false
    }
  },
  computed: {
    ...mapState('keyValues', ['getKeyValuesOutput']),
    ...mapState('keyValues', ['deleteKeyValueOutput']),
    keyValuesInfo: function() {
      return this.getKeyValuesOutput && this.getKeyValuesOutput.data ? this.getKeyValuesOutput.data : null;
    },
    items: function()
    {
      return this.keyValuesInfo ? this.keyValuesInfo : [];
    },
    pages: function()
    {
      return this.getKeyValuesOutput ? this.getKeyValuesOutput.totalPages : 1;
    },
  },
  mounted: function()
  {
    this.loadKeyValues();
  },
  methods: {
    ...mapActions('keyValues', ['getKeyValues']),
    ...mapActions('keyValues', ['deleteKeyValue']),
    loadKeyValues() {
      const input = new InputGetList();
      input.pageNumber = 1;
      input.pageSize = this.itemsPerPage;
      input.searchText = this.searchText;
      input.sorter = this.sorterValue.asc ? 'ascending' : 'descending';
      input.propertyName = this.sorterValue.column;
      
      this.getKeyValues(input);
    },
    rowClicked (item, index) {
      this.$router.push({name: "KeyValueEdit", query: { id: item.id }, params: {key: item.key} });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        case 'edit':
        {
          this.$router.push({name: "KeyValueEdit", query: { id: item.id }, params: {key: item.key} });
          break;
        }
        case 'delete':
        {
          if(confirm(this.$i18n.tc('confirmRemove', item.key, { name: item.key }))){
            this.deleteKeyValue(item.id);
          }
          break;
        }
      }
    },
    addKeyValue() {
      this.$router.push({name: "KeyValueAdd"});
    },
    searchClicked(searchText) {
      this.searchText = searchText;
      this.loadKeyValues();
    },
    updateItemsRequested(pageNumber) {
      const input = new InputGetList();
      input.pageNumber = pageNumber;
      input.pageSize = this.itemsPerPage;
      input.searchText = this.searchText;
      input.sorter = this.sorterValue.asc ? 'ascending' : 'descending';
      input.propertyName = this.sorterValue.column;
      
      this.getKeyValues(input);
    },
    sorterValueChanged(sorterValue) {
      this.sorterValue = sorterValue;
      this.loadKeyValues();
    }
  },
  watch: {
    deleteKeyValueOutput: function() {
      if (this.deleteKeyValueOutput === true) {
        this.loadKeyValues();
      }
    }
  }
}
</script>
